import { Injectable } from '@angular/core';
import { EMPTY, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DirectoryStateService {

  private readonly EXPANDED_KEY = 'expandedFolderIds';
  private readonly FOLDER_TAB_STATE_KEY = 'folderTabState';

  saveExpandedFolders(ids: number[]): Observable<void> {
      localStorage.setItem(this.EXPANDED_KEY, JSON.stringify(ids));
      return EMPTY;
    }

    getExpandedFolderIds(): Observable<number[]> {
      const raw = localStorage.getItem(this.EXPANDED_KEY);
      const ids = raw ? JSON.parse(raw) : [];
      return of(ids);
    }

    saveFolderAndTab(folderId: number, tabIndex: number): Observable<void> {
      const state = { folderId, tabIndex };
      localStorage.setItem(this.FOLDER_TAB_STATE_KEY, JSON.stringify(state));
      return EMPTY;
    }

    getFolderAndTab(): Observable<{ folderId: number; tabIndex: number } | null> {
      const raw = localStorage.getItem(this.FOLDER_TAB_STATE_KEY);
      const result = raw ? JSON.parse(raw) : null;
      return of(result);
    }

  constructor() { }
  }
